import { Fragment } from "react";

import useNTGroupMembers from "./UseNTGroupMembers";

import NTGroupMemberIdForm from "../components/forms/memberId/NTGroupMemberIdForm";
import NTGroupsLoadingModal from "../components/dialogs/loading/NTGroupsLoadingModal";
import NTGroupMemberAddModal from "../components/dialogs/memberAdd/NTGroupMemberAddModal";
import NTGroupMembersFormGrid from "../components/grids/membersForm/NTGroupMembersFormGrid";
import NTGroupMemberDeleteModal from "../components/dialogs/memberDelete/NTGroupMemberDeleteModal";
import NTGroupMemberDupModal from "../components/dialogs/memberDup/NTGroupMemberDupModal";

import Headings from "@usas/ui-web/components/headings/Headings";

const NTGroupMembers = () => {
  const {
    isGridLoading,
    gridData,
    state,
    onCloseAddPopup,
    onCloseDupPopup,
    onCloseDeletePopup,
    onSubmitMemberIdForm,
    onSubmitMembersFormGrid,
    onEditGroupMemberClicked,
    onDeleteGroupMemberClicked
  } = useNTGroupMembers();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>Members</Headings.H3>
        </div>
      </div>
      {state.displayAddPopup !== true && state.displayDupPopup !== true &&
        <NTGroupMemberIdForm onSubmitFormCallback={onSubmitMemberIdForm} />
      }
      <NTGroupMembersFormGrid
        gridData={gridData}
        isLoading={isGridLoading}
        onSubmitFormCallback={onSubmitMembersFormGrid}
        onEditClicked={onEditGroupMemberClicked}
        onDeleteClicked={onDeleteGroupMemberClicked} />
      {state.displayAddPopup === true &&
        <NTGroupMemberAddModal memberObj={state.addGroupMemberObj} onCloseModal={onCloseAddPopup} />
      }
      {state.displayDeletePopup === true &&
        <NTGroupMemberDeleteModal groupMemberObj={state.deleteGroupMemberObj} onCloseModal={onCloseDeletePopup} />
      }
      {state.displayDupPopup === true &&
        <NTGroupMemberDupModal groupMemberObj={state.dupGroupMemberObj} onCloseModal={onCloseDupPopup} />
      }
      <NTGroupsLoadingModal isLoading={false} />
    </Fragment>
  );
};

export default NTGroupMembers;